import { Card } from "./models/index.js";
import G from "./card-manager-factory.js";
import { MUST_BE_CARD_WARNING_SUFFIX as Q } from "../common/constants.js";
import r from "../managers/braze-instance.js";
import { logger as E } from "../../shared-lib/index.js";
export function logCardDismissal(o) {
  return !!r.rr() && (o instanceof Card ? G.ea().Jt(o).W : (E.error("card " + Q), !1));
}